/**
 * @license
 *
 * Copyright IBM Corp. 2020
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */
export { default as CustomElement } from '../../components/card/card.js';
import createReactCustomElementType, {
  booleanSerializer,
} from '@carbon/web-components/es/globals/wrappers/createReactCustomElementType.js';
import PropTypes from 'prop-types';
import settings from 'carbon-components/es/globals/js/settings.js';
import ddsSettings from '@carbon/ibmdotcom-utilities/es/utilities/settings/settings.js';
var prefix = settings.prefix;
var ddsPrefix = ddsSettings.stablePrefix;
export var descriptor = {
  border: {
    serialize: booleanSerializer,
  },
  colorScheme: {
    attribute: 'color-scheme',
  },
  href: {},
  pictogramPlacement: {
    attribute: 'pictogram-placement',
  },
  logo: {
    serialize: booleanSerializer,
  },
};
export var propTypes = {
  /**
   * An optional 1px border surrounding the component.
   */
  border: PropTypes.bool,
  /**
   * The color scheme.
   * A typical use case of using another color scheme of card is having a "CTA" purpose of card at the last in card group.
   *
   * Color scheme options are: "inverse" and "light"
   */
  colorScheme: PropTypes.string,
  /**
   * Link `href`.
   */
  href: PropTypes.string,
  /**
   * Pictogram placement
   */
  pictogramPlacement: PropTypes.string,
  /**
   * Whether or not to apply the logo style.
   */
  logo: PropTypes.bool,
};
const Component = createReactCustomElementType(
  ''.concat(ddsPrefix, '-card'),
  descriptor
);
Component.propTypes = propTypes;
export default Component;
